import React, { FC } from 'react';
import './style.scss';

type Props = {
  title: string;
  data: {
    name: string;
    profile_image: string;
    duration: number;
    no_of_orders: string;
    completed_order_percent: number;
    time_difference: number;
  }[];
  loading: boolean;
  duration?: boolean;
};
const ShiningStars: FC<Props> = ({ title, data, loading, duration }) => {
  return (
    <div className='shining_star'>
      <h4 className='sm:text-2xl mb-8'>{title}</h4>
      {loading ? (
        <div className='flex justify-center items-center'>
          <div className='animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900 mt-8'></div>
        </div>
      ) : (
        <div className='flex flex-wrap gap-6 h-[80vh] overflow-y-scroll'>
          {data &&
            data?.map(
              (
                { name, no_of_orders, completed_order_percent, profile_image, time_difference },
                index
              ) => (
                <div
                  className='w-full lg:w-[410px] h-[171px] gap-4 items-center relative star_card'
                  key={index}>
                  <div className='w-[140px] h-[155px]'>
                    <img src={profile_image} alt='star' className='w-full h-full' />
                  </div>
                  <div className='mr-2 text'>
                    <h6>{name?.split(' ').slice(0, 2).join(' ')}</h6>
                    <h3>{no_of_orders} orders</h3>
                    <p className='mt-[40px]'>
                      {duration
                        ? `
                  ${
                    Math.round(time_difference).toString()?.includes('-')
                      ? Math.round(time_difference) * -1
                      : Math.round(time_difference)
                  }  mins ${
                            Math.round(time_difference).toString()?.includes('-')
                              ? 'slower'
                              : 'faster'
                          } than other riders
                  `
                        : `Completed ${Math.round(completed_order_percent)}% of all orders`}
                    </p>
                  </div>
                  <div className='absolute top-2 right-2 tag'>
                    <p>{index + 1}</p>
                  </div>
                </div>
              )
            )}
        </div>
      )}
    </div>
  );
};

export default ShiningStars;
